import { CToast } from '@coreui/react';
import React from 'react';

const BaseToast = React.memo(({ children, ...rest }) => {
  return <CToast {...rest}>{children}</CToast>;
});

export default BaseToast;
